import { ApolloError, useMutation } from '@apollo/client'

import { Form, FormUpdateInput, MutationUpdateFormArgs } from '@types'

import { MUTATION_UPDATE_FORM } from '@libs/apollo/mutations/form.mutation'

interface Data {
  updateForm: Form
}

interface UseUpdateFormProps {
  onCompleted?: () => void
}

export const useUpdateForm = (
  props?: UseUpdateFormProps,
): {
  updateForm: (input: FormUpdateInput) => void
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [updateForm, { loading, error, data }] = useMutation<Data, MutationUpdateFormArgs>(MUTATION_UPDATE_FORM, {
    notifyOnNetworkStatusChange: true,
  })

  const _updateForm = (input: FormUpdateInput) => {
    updateForm({ variables: { input }, onCompleted: props?.onCompleted })
  }

  return { updateForm: _updateForm, loading, error, data }
}
